import axiosx from '../axios/index';

export async function fetchCity() {
  const url = `/dropdown/city`;

  try {
    const data = await axiosx.get(url);
    return data;
  } catch (error) {
    return { success: false, error };
  }
}
export async function fetchServiceRequestType() {
  const url = `/dropdown/serviceRequestType`;

  try {
    const data = await axiosx.get(url);
    return data;
  } catch (error) {
    return { success: false, error };
  }
}
export async function fetchCf_nw_alwasf() {
  const url = `/dropdown/serviceRequestType`;

  try {
    const data = await axiosx.get(url);
    return data;
  } catch (error) {
    return { success: false, error };
  }
}
export async function fetchTechnical() {
  const url = `/dropdown/technical`;

  try {
    const data = await axiosx.get(url);
    return data;
  } catch (error) {
    return { success: false, error };
  }
}
export async function fetchSuburb() {
  const url = `/dropdown/suburb`;

  try {
    const data = await axiosx.get(url);

    return data;
  } catch (error) {
    return { success: false, error };
  }
}
export async function fetchDeviceType() {
  const url = `/dropdown/deviceType`;

  try {
    const data = await axiosx.get(url);

    return data;
  } catch (error) {
    return { success: false, error };
  }
}
export async function fetchAccountType() {
  const url = `/dropdown/accountType`;

  try {
    const data = await axiosx.get(url);

    return data;
  } catch (error) {
    return { success: false, error };
  }
}
export async function fetchComplaintValidity() {
  const url = `/dropdown/complaintvalidity`;

  try {
    const data = await axiosx.get(url);

    return data;
  } catch (error) {
    return { success: false, error };
  }
}
export async function fetchMessage(name) {
  let x = encodeURIComponent(name);
  const url = `/dropdown/message/name/${x}`;

  try {
    const data = await axiosx.get(url);

    return data;
  } catch (error) {
    return { success: false, error };
  }
}
